// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "assistant_message".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { assistantMessageRoleValues } from '@borradh-workspace/labels';
/** Response atom for the "assistant_message" table (1:1 with a DB row, on the wire). */
export const assistantMessageAtomSchema = z.object({
    id: z.string(),
    conversationId: z.string(),
    role: z.enum(assistantMessageRoleValues),
    content: z.string().nullable(),
    toolCalls: z.unknown().nullable(),
    toolResults: z.unknown().nullable(),
    attachments: z.unknown().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=assistantMessage.js.map